module.exports = __webpack_public_path__ + "5f6775526acbbe66d80a636db8874d24.svg";